(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-option"] && !Shopify.designMode) return;
  try {
    class SwatchOverflow extends HTMLElement {
    constructor() {
      super();
      this.check = this.check.bind(this);
      this.handleWrapChange = this.handleWrapChange.bind(this);
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.isUpdating = false;
      this.enableSessionPrevalence = true;
      this.userHasClickedToggle = false;
    }

    connectedCallback() {
      // Set up observers
      this.resizeObserver = new ResizeObserver(this.check);
      this.resizeObserver.observe(this);

      this.mutationObserver = new MutationObserver(this.check);
      this.mutationObserver.observe(this, { 
        childList: true,
        subtree: false,
        attributes: false
      });

      // Set up event listeners
      this.addEventListener('wrapchange', this.handleWrapChange);
      
      // Set up toggle button click handler
      this.setupToggleButton();

      // Initial check with a small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        requestAnimationFrame(this.check);
      });
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      this.removeEventListener('wrapchange', this.handleWrapChange);
    }

    setupToggleButton() {
      const toggleButton = this.querySelector('.variant-option--swatches-toggle');
      if (toggleButton) {
        // Remove any existing listeners to prevent duplicates
        toggleButton.removeEventListener('click', this.handleToggleClick);
        toggleButton.addEventListener('click', this.handleToggleClick);
      }
    }


    check() {
      // Prevent infinite loops when we're updating the DOM
      if (this.isUpdating) {
        return;
      }

      const swatches = this.querySelectorAll(':scope > a, :scope > label');
      
      // If no swatches, don't proceed
      if (swatches.length === 0) {
        return;
      }

      let lastInRowIndex = swatches.length - 1;
      let isWrapped = false;

      if (swatches.length > 1) {
        const firstItemTop = swatches[0].getBoundingClientRect().top;

        for (let i = 1; i < swatches.length; i++) {
          const currentItemTop = swatches[i].getBoundingClientRect().top;
          if (currentItemTop > firstItemTop + 1) {
            isWrapped = true;
            lastInRowIndex = i - 1;
            break;
          }
        }
      }

      if (isWrapped) {
        this.setAttribute('wrapped', '');
      } else {
        this.removeAttribute('wrapped');
      }

      // Mark as initialized after first check
      if (!this.hasAttribute('data-initialized')) {
        this.setAttribute('data-initialized', '');
      }

      this.dispatchEvent(new CustomEvent('wrapchange', {
        bubbles: true,
        composed: true,
        detail: {
          isWrapped: isWrapped,
          lastInRowIndex: lastInRowIndex
        }
      }));
    }

    handleWrapChange(event) {
      const { isWrapped, lastInRowIndex } = event.detail;
      const allSwatches = this.querySelectorAll(':scope > a, :scope > label');
      const uniqueKey = this.getUniqueKey();
      const isExpanded = this.enableSessionPrevalence && this.userHasClickedToggle && sessionStorage.getItem(`swatch-expanded-${uniqueKey}`) === 'true';

      this.isUpdating = true;

      if (isWrapped) {
        const toggleButton = this.querySelector('.toggle-text');

        const overflowCount = allSwatches.length - lastInRowIndex;

        if (toggleButton && overflowCount > 0) {
          toggleButton.textContent = `+${overflowCount}`;
        }

        if (isExpanded) {
          allSwatches.forEach(swatch => {
            swatch.classList.remove('variant-option__button-label--hidden');
            swatch.classList.add('variant-option__button-label--showing');
          });
          
          const toggleButtonElement = this.querySelector('.variant-option--swatches-toggle');
          if (toggleButtonElement) {
            toggleButtonElement.style.display = 'none';
          }
        } else {
          allSwatches.forEach((swatch, index) => {
            if (index >= lastInRowIndex) {
              swatch.classList.add('variant-option__button-label--hidden');
            } else {
              swatch.classList.remove('variant-option__button-label--hidden');
            }
          });
        }
      } else {
        allSwatches.forEach(swatch => {
          swatch.classList.remove('variant-option__button-label--hidden');
        });
        
        if (this.enableSessionPrevalence && this.userHasClickedToggle) {
          sessionStorage.removeItem(`swatch-expanded-${uniqueKey}`);
        }
      }

      requestAnimationFrame(() => {
        this.isUpdating = false;
      });
    }

    handleToggleClick() {
      const hiddenSwatches = this.querySelectorAll('.variant-option__button-label--hidden');
      const toggleButton = this.querySelector('.variant-option--swatches-toggle');
      
      if (hiddenSwatches.length > 0) {
        const uniqueKey = this.getUniqueKey();
        this.userHasClickedToggle = true;
        if (this.enableSessionPrevalence) {
          sessionStorage.setItem(`swatch-expanded-${uniqueKey}`, 'true');
        }
        
        if (toggleButton) {
          toggleButton.style.display = 'none';
        }
        
        hiddenSwatches.forEach((swatch, index) => {
          setTimeout(() => {
            swatch.classList.remove('variant-option__button-label--hidden');
            swatch.classList.add('variant-option__button-label--showing');
          }, index * 50);
        });
      }
    }

    getUniqueKey() {
      const containerHandle = this.dataset.swatchesContainer || 'unknown';
      const key = containerHandle.replace(/[^a-zA-Z0-9-]/g, '-');
      
      return key;
    }
  }

  if (!customElements.get('swatch-overflow')) {
    customElements.define('swatch-overflow', SwatchOverflow);
  }

  document.addEventListener('variant:update', () => {
    const swatchOverflowElements = document.querySelectorAll('swatch-overflow');
    swatchOverflowElements.forEach((element) => {
      if (element.check) {
        requestAnimationFrame(() => {
          element.check();
        });
      }
    });
  });

  // Size Guide Modal functionality
  document.addEventListener('DOMContentLoaded', function() {
    const sizeGuideTriggers = document.querySelectorAll('.size-guide-trigger');
    
    sizeGuideTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const modalId = trigger.dataset.modalId;
        if (!modalId) return;
        
        // Get the product URL from the closest variant picker
        const variantPicker = trigger.closest('variant-picker');
        const productUrl = variantPicker ? variantPicker.dataset.productUrl : null;
        
        if (!productUrl) {
          console.warn('Size Guide Modal: Product URL not found');
          return;
        }
        
        // Construct the size guide URL
        const sizeGuideUrl = `${productUrl}?view=size-guide`;
        
        // Open the modal with the size guide content
        document.dispatchEvent(new CustomEvent(`${modalId}:open`, { 
          detail: { sectionUrl: sizeGuideUrl } 
        }));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
